import { render } from "./LaravelVueDatatables.vue?vue&type=template&id=9c32ba98"
import script from "./LaravelVueDatatables.vue?vue&type=script&lang=js"
export * from "./LaravelVueDatatables.vue?vue&type=script&lang=js"

import "./LaravelVueDatatables.vue?vue&type=style&index=0&id=9c32ba98&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__